if (!customElements.get('rea-registration-event')) {
    class ReaRegistrationEvent extends HTMLElement {
        constructor() {
            super();
            this.email = this.dataset.email;
            this.emailSha256 = this.dataset.emailSha256 || '';
            this.customerId = this.dataset.customerId;
            const isNewFlag = localStorage.getItem('is-account-new');
            this.isNewAccount = isNewFlag === 'true' ? true : false;
        }

        connectedCallback() {
            
            if (!this.isNewAccount) {
                return;
            }
            

            const tealiumPubObj = {
                'User_Email_MD5': this.email,
                'User_Email_SHA256': this.emailSha256,
                'User_Id': this.customerId
            }

            try {
                sessionStorage.setItem('tealium_account_created_pending', '1');
                sessionStorage.removeItem('tealium_account_created_consumed');
            } catch (error) {
                console.warn('[REA][rea-registration-event] unable to persist account-created flag:', error);
            }

            let tries = 0;
            const maxTries = 10;
            const publishInterval = setInterval(() => {
                if (typeof publish === 'function' || tries >= maxTries) {
                    tries++;
                    try {
                        publish(PUB_SUB_EVENTS.accountCreated, tealiumPubObj);
                    } catch(e){
                        console.warn('[REA][rea-registration-event] publish failed:', e);
                    }
                    clearInterval(publishInterval);
                    localStorage.setItem('is-account-new', false);
                }
            }, 1000);

            // Create customer access token if needed
            try {
                const hasSessionToken = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('customerAccessToken'));
                
                if (hasSessionToken) {
                    localStorage.removeItem('c_profile');
                } else {
                    this.createCustomerAccessToken();
                }
            } catch (e) {
                console.error('[REA][rea-registration-event] ✗ Error checking session token:', e);
            }
        }

        async createCustomerAccessToken(){
            const c_profile_raw = localStorage.getItem('c_profile');
            
            if (!c_profile_raw) {
                console.error('[REA][rea-registration-event] ✗ ABORT: No c_profile in localStorage');
                return;
            }
            
            let storefrontToken = document.getElementById('storefront-access-token')?.value;
            let storefrontEndpoint = document.getElementById('storefront-endpoint')?.value;

            // Fallback to localStorage if not found
            if (!storefrontToken) {
                storefrontToken = localStorage.getItem('storefrontToken');
            }
            if (!storefrontEndpoint) {
                storefrontEndpoint = localStorage.getItem('storefrontEndpoint');
            }

            if (!storefrontToken || !storefrontEndpoint) {
                console.error('[REA][rea-registration-event] ✗ ABORT: Missing storefront config');
                console.error('[REA][rea-registration-event]   - storefrontToken:', !!storefrontToken);
                console.error('[REA][rea-registration-event]   - storefrontEndpoint:', storefrontEndpoint);
                return;
            }

            const encodedString = c_profile_raw;
            
            let decodedString;
            try {
                decodedString = atob(encodedString);
            } catch (e) {
                console.error('[REA][rea-registration-event] ✗ ABORT: Failed to atob c_profile:', e);
                return;
            }
            
            let dataObj;
            try {
                dataObj = JSON.parse(decodedString);
            } catch (e) {
                console.error('[REA][rea-registration-event] ✗ ABORT: Failed to parse c_profile:', e);
                console.error('[REA][rea-registration-event]   - Decoded string:', decodedString);
                return;
            }

            const input = {
                email: dataObj[0].e,
                password: dataObj[0].p
            }
            
            
            try {
                
                const fetchStartTime = Date.now();
                const response = await fetch(storefrontEndpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": storefrontToken
                    },
                    body: JSON.stringify({
                        query: `#graphql
                                mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
                                    customerAccessTokenCreate(input: $input) {
                                        customerAccessToken {
                                            accessToken
                                        }
                                        customerUserErrors {
                                            message
                                        }
                                    }
                                }
                            `,
                        variables: { input }
                    })
                });
                
                const fetchDuration = Date.now() - fetchStartTime;

                const result = await response.json();
                
                const token = result.data?.customerAccessTokenCreate?.customerAccessToken;
                const errors = result.data?.customerAccessTokenCreate?.customerUserErrors;

                
                if (result.error) {
                    console.error('[REA][rea-registration-event] ✗ GraphQL top-level error:', result.error);
                }
                
                if (errors && errors.length > 0) {
                    console.error('[REA][rea-registration-event] ✗ customerUserErrors found:');
                    errors.forEach((err, idx) => {
                        console.error('[REA][rea-registration-event]   Error', idx + 1, ':', err);
                    });
                }

                if (token && token.accessToken) {
                    try {
                        sessionStorage.setItem('customerAccessToken', token.accessToken);
                        
                        const verified = sessionStorage.getItem('customerAccessToken');
                        
                        localStorage.removeItem('c_profile');
                    } catch (storageErr) {
                        console.warn('[REA][rea-registration-event] ⚠ sessionStorage unavailable, using localStorage fallback:', storageErr);
                        localStorage.setItem('customerAccessToken', token.accessToken);
                        
                        // Verify fallback
                        const verified = localStorage.getItem('customerAccessToken');
                    }
                } else {
                    console.error('[REA][rea-registration-event] ✗✗✗ NO TOKEN RECEIVED ✗✗✗');
                    console.error('[REA][rea-registration-event]   - token object:', token);
                    console.error('[REA][rea-registration-event]   - Full customerAccessTokenCreate:', result.data?.customerAccessTokenCreate);
                }
            }
            catch (error) {
                console.error('[REA][rea-registration-event] ═══════════════════════════════════════');
                console.error('[REA][rea-registration-event] ✗✗✗ EXCEPTION in createCustomerAccessToken ✗✗✗');
                console.error('[REA][rea-registration-event]   - Error type:', error.name);
                console.error('[REA][rea-registration-event]   - Error message:', error.message);
                console.error('[REA][rea-registration-event]   - Error stack:', error.stack);
                console.error('[REA][rea-registration-event] ═══════════════════════════════════════');
            }
        }

    }

    customElements.define('rea-registration-event', ReaRegistrationEvent);
}
